// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Bb1Q","title":"Header_title__1wb7-","side":"Header_side__2S6pz"};